<template>
  <!-- Destaque total nesta parte.
Incluir o vídeo com som.
Incluir fotos do pendrive.
Viabilizar fotos 360.
  Carousel com fotos no topo.-->
  <section>
    <Banner value="Espaço Físico"/>
    <Carousel/>
    <Caracteristicas/>

    <section style="background:none; padding:50px 0;">
      <v-container grid-list-xl>
        <v-layout justify-space-between row wrap fill-height>
          <v-flex sm12 md5 lg4 xl3>
            <h2>
              Espaços da
              <small style="display:block">Escola Engenho</small>
            </h2>
            <p
              class=""
              style="text-align:left;"
            >Cada detalhe das instalações físicas da escola foi carinhosamente pensado para favorecer a aprendizagem, facilitar a interação social e permitir o contato com a natureza.</p>
            <p style="text-align:left;">Ao mesmo tempo, oferece segurança, conforto e acessibilidade. Uma infraestrutura incrível capaz de receber com qualidade a todos os seus estudantes que inclui:</p>
            <Locais/>
            <br>
            <br>
          </v-flex>
          <v-flex sm12 md7 lg8>
            <Fotos/>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section class="section" style="background:#DDD">
      <Video/>
    </section>
  </section>
</template>

<script>
import Banner from "../../components/Banner";
import Carousel from "../../components/espaco/Carousel.vue";
import Locais from "../../components/espaco/Locais.vue";
import Caracteristicas from "../../components/espaco/Caracteristicas.vue";
import Fotos from "../../components/espaco/Fotos.vue";
import Diferenciais from "../../components/espaco/Diferenciais.vue";
import Video from "../../components/espaco/Video.vue";

export default {
  data: () => ({}),
  components: {
    Banner,
    Carousel,
    Locais,
    Fotos,
    Diferenciais,
    Caracteristicas,
    Video
  }
};
</script>


<style lang="scss">
.videoWrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
